import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import GoogleAuthButton from "@/components/GoogleAuthButton";

export default function LoginPage() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(email, password);
      toast.success("Welcome back");
      // Staff members land on the portal, not the customer dashboard.
      // Keeps the two experiences visually and functionally separate.
      if (u && ["owner", "admin", "sales"].includes(u.role)) {
        nav("/staff");
      } else {
        nav("/dashboard");
      }
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-20">
      <div className="bg-white rounded-2xl border border-brand-subtle p-8">
        <p className="label-eyebrow text-gray-500 mb-2">Welcome back</p>
        <h1 className="font-display text-4xl brand-forest mb-8">Log in to To-Let Rentals</h1>

        <GoogleAuthButton label="Continue with Google" />

        <div className="flex items-center gap-3 my-6">
          <div className="flex-1 h-px bg-[#EFE3D0]" />
          <span className="text-[10px] font-bold uppercase tracking-widest text-gray-400">or with email</span>
          <div className="flex-1 h-px bg-[#EFE3D0]" />
        </div>

        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="text-sm font-semibold text-gray-700 mb-1 block">Email</label>
            <Input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
          </div>
          <div>
            <label className="text-sm font-semibold text-gray-700 mb-1 block">Password</label>
            <Input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
          </div>
          <Button data-testid="login-submit" type="submit" disabled={busy} className="w-full tlr-gold-btn rounded-full h-12">
            {busy ? "Signing in…" : "Log in"}
          </Button>
        </form>
        <p className="text-sm text-gray-500 mt-6 text-center">
          New here? <Link to="/register" className="brand-forest font-semibold hover:underline">Create an account</Link>
        </p>
      </div>
    </div>
  );
}
